module.exports = __webpack_public_path__ + "static/img/sword.09290411.svg";